// Content of the "À propos" page — editable independently
// Tone: direct, artisanal, no empty superlatives.

export const ABOUT = {
  hero: {
    kicker: "À propos · VistaWash",
    title: "Un atelier. Une méthode.\nAucun raccourci.",
    subtitle:
      "VistaWash, c'est un atelier de detailing à Châtelet. Chaque véhicule reçoit le temps et les produits qu'il mérite. Rien de plus, rien de moins.",
    ctaPrimary: { label: "Demander mon diagnostic", href: "#contact" },
    ctaSecondary: { label: "Voir l'atelier", href: "#atelier" },
  },

  story: {
    kicker: "L'histoire",
    title: "D'un garage, à un atelier.",
    paragraphs: [
      "J'ai commencé en polissant les voitures d'amis, dans un garage. Ce qui m'a marqué très vite, c'est le contraste entre une peinture négligée et une peinture réellement corrigée. Pas maquillée : corrigée. La différence tient dans la méthode.",
      "VistaWash est né de cette obsession du geste précis et du temps consacré à chaque véhicule. Je préfère traiter moins de voitures mais bien, plutôt que d'enchaîner les prestations superficielles.",
      "L'atelier est basé à Châtelet, dans la région de Charleroi. Il est pensé pour un seul objectif : contrôler chaque étape, sous éclairage adapté, avec les bons produits. C'est ce qui explique pourquoi une prestation prend le temps qu'elle prend.",
    ],
  },

  approach: {
    kicker: "Notre approche",
    title: "Comment on travaille.",
    subtitle: "Quatre principes qui expliquent pourquoi une prestation VistaWash prend le temps qu'elle prend.",
    items: [
      {
        icon: "Hand",
        title: "Tout à la main",
        text: "Lavage main, décontamination à l'argile, polissage panneau par panneau, application des protections à la main. Aucun tunnel, aucune brosse rotative. Le geste appartient à un humain.",
      },
      {
        icon: "FlaskConical",
        title: "Le bon produit pour la bonne surface",
        text: "Cuir, cuir perforé, alcantara, tissu, plastique dur, plastique souple, vernis récent, vernis ancien, mat, brillant : chaque surface demande un pH et un abrasif spécifiques. Nous ne travaillons pas avec un produit universel.",
      },
      {
        icon: "Clock",
        title: "Le temps qu'il faut",
        text: "Un nettoyage complet demande 4 à 6h. Un polissage 2 étapes, 6 à 8h. Une céramique préparée complète, 1 à 3 jours. Nous refusons de compresser artificiellement ces durées.",
      },
      {
        icon: "Search",
        title: "La finition dans les détails",
        text: "Joints de portière, entourages de badge, plis de cuir, boutons de commande, contours de vitre : ce sont ces zones qui distinguent un travail correct d'un travail livré. Chaque véhicule passe par un contrôle final sous LED.",
      },
    ],
  },

  workshop: {
    kicker: "L'atelier",
    title: "Un espace pensé pour le travail précis.",
    subtitle:
      "Éclairage d'inspection, air maîtrisé, matériel professionnel. L'atelier n'est pas un décor : c'est une condition du résultat.",
    photos: [
      { src: "about_workshop_wide", caption: "L'espace de travail principal, éclairage LED plafond." },
      { src: "about_led_inspection", caption: "Contrôle du vernis sous lampe LED d'inspection." },
      { src: "about_polisher", caption: "Polissage panneau par panneau, machine DA Rupes." },
      { src: "about_interior_detail", caption: "Finition intérieur au microfibre, gant nitrile." },
    ],
  },

  commitments: {
    kicker: "Nos engagements",
    title: "Ce que vous obtenez à chaque prestation.",
    subtitle: "Des engagements concrets et vérifiables. Pas des slogans.",
    items: [
      {
        title: "Diagnostic offert avant chaque prestation",
        text: "Nous examinons votre véhicule sous éclairage LED avant tout devis. Vous savez exactement ce qui sera fait — et pourquoi.",
      },
      {
        title: "Devis clair, sans surprise",
        text: "Un seul prix communiqué à l'avance, incluant les suppléments véhicule et les options. Aucune facturation surprise en fin de prestation.",
      },
      {
        title: "Réponse rapide par WhatsApp, lun–sam 9h–18h",
        text: "Chaque demande de devis reçoit une réponse rapide par WhatsApp, du lundi au samedi de 9h à 18h. Par téléphone ou email aussi — vous choisissez.",
      },
      {
        title: "Certificat écrit sur les traitements céramique",
        text: "Céramique 1, 3 ou 5 ans : vous repartez avec un certificat nominatif indiquant produit, lot et durée. Un standard exigé par les fabricants, rarement appliqué.",
      },
      {
        title: "Entretien de garantie céramique en atelier",
        text: "Contrôle annuel en atelier pour renouveler la protection hydrophobe. C'est le seul moyen honnête de garantir la durée annoncée.",
      },
    ],
  },

  stats: [
    { value: 300, suffix: "+", label: "Véhicules traités" },
    { value: 2, suffix: " ans", label: "D'activité à Châtelet" },
    { value: 5.0, suffix: "/5", label: "Note moyenne clients", decimals: 1 },
  ],

  finalCta: {
    kicker: "Venez voir par vous-même",
    title: "Passez à l'atelier.\nJugez sur place.",
    subtitle:
      "Le meilleur moyen de comprendre notre approche, c'est de venir. Prenez rendez-vous pour un diagnostic — c'est gratuit et sans engagement.",
    primary: { label: "Demander mon diagnostic", href: "#contact" },
  },
};

export default ABOUT;
